module.exports = __webpack_public_path__ + "img/2370.78a5523e.gif";